<section class="no-auth-page">
  <header>
    <h3>Two-factor Authentication</h3>
    <h4>Your account is protected by two-factor authentication</h4>
  </header>

  <form
    [formGroup]="form"
    class="ht-form ht-form--auth"
    (ngSubmit)="onSubmit()"
  >
    <div class="ht-form-item">
      <div class="ht-form-item-title">Code</div>
      <div class="ht-form-item-control">
        <ht-input
          label="Code"
          formControlName="code"
          fullWidth="true"
          helpText="Find it in your authenticator app. You can also use a recovery code."
        ></ht-input>
      </div>
    </div>

    <div class="feedback-wrapper">
      @if (error()) {
        <div class="error-alert">
          <i class="fa-solid fa-circle-xmark"></i>
          <span>{{ error() }}</span>
        </div>
      }

      <button
        ht-button-primary
        type="submit"
        size="large"
        [isLoading]="isLoading()"
        [isDisabled]="form.invalid"
        fullWidth="true"
      >
        Verify
      </button>

      <button
        ht-button-secondary
        size="large"
        [isDisabled]="isLoading()"
        fullWidth="true"
        (click)="onCancel()"
      >
        Cancel
      </button>
    </div>
  </form>
</section>
